import { useContext, useMemo } from 'react';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { resultCardStyles } from 'marketplace-ui-common/storefront/utils/resultCardStyles';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import Carousel from 'marketplace-ui-common/components/Carousel';
import CollectionCard from 'marketplace-ui-common/collections/components/CollectionCard';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import { getAppStorefrontRoute } from '../../utils/urls';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { useAppContext } from '../../context/AppContext.tsx';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCollectionCard = styled(CollectionCard).withConfig({
  displayName: "AppCollectionsCardGrid__StyledCollectionCard",
  componentId: "w9onvs-0"
})(["", ""], resultCardStyles);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "AppCollectionsCardGrid__StyledRouterLink",
  componentId: "w9onvs-1"
})(["display:flex;align-items:stretch;"]);
export default function AppCollectionsCardGrid() {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const {
    maxCardsPerPage
  } = useResponsiveProps({
    maxCardsPerPage: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.LG]: 2,
      [ScreenSizes.XL]: 3
    }
  });
  const appContext = useAppContext();
  const {
    getDisplayedCollections,
    requestState: publishedAppCollectionsRequestState
  } = usePublishedCollections({
    appContext: appContext,
    offeringType: 'APP'
  });
  const displayedCollections = getDisplayedCollections();
  const collectionCards = useMemo(() => displayedCollections.map((collection, index) => {
    if (!collection.publishedListing) {
      return null;
    }
    return /*#__PURE__*/_jsx(StyledRouterLink, {
      onClick: () => trackInteraction('click collection', {
        value: collection.publishedListing.slug,
        itemIndex: index
      }),
      style: {
        minHeight: 292
      },
      to: getAppStorefrontRoute(collection.publishedListing.slug),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(StyledCollectionCard, {
        collection: collection,
        maxHeight: 160
      })
    }, `collection-${collection.id}`);
  }), [displayedCollections, trackInteraction]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: publishedAppCollectionsRequestState,
    children: /*#__PURE__*/_jsx(Carousel, {
      className: "p-x-0",
      cards: collectionCards,
      maxCardsPerPage: maxCardsPerPage
    })
  });
}